import {
  API_BASE,
  AUTH_API_BASE,
  ENVIROMENT_TYPE,
  BUYER_HOST_DEV,
  MANAGEMENT_HOST_DEV,
  SEARCH_HOST_DEV,
  SELLER_HOST_DEV,
  SHARED_HOST_DEV,
  BUYER_HOST_PROD,
  MANAGEMENT_HOST_PROD,
  SEARCH_HOST_PROD,
  SELLER_HOST_PROD,
  SHARED_HOST_PROD,
  SolrAPIPrefix,
  DATA_HOST_PROD,
  DATA_HOST_DEV,
  DataAPIPrefix,
} from '../../config/constants';

export function getCurrentEnviromentType() {
  if (import.meta && (import.meta as any)?.env?.MODE) {
    return (import.meta as any).env.MODE === ENVIROMENT_TYPE.PRODUCTION
      ? ENVIROMENT_TYPE.PRODUCTION
      : ENVIROMENT_TYPE.DEVELOPMENT;
  }
  return process.env.NEXT_PUBLIC_ENVIROMENT === ENVIROMENT_TYPE.PRODUCTION
    ? ENVIROMENT_TYPE.PRODUCTION
    : ENVIROMENT_TYPE.DEVELOPMENT;
}

export class Config {
  managementApiHost: string;
  managementApiPrefix: string;
  sellerApiHost: string;
  sellerApiPrefix: string;
  buyerApiHost: string;
  buyerApiPrefix: string;
  authApiPrefix: string;
  sharedApiHost: string;
  sharedApiPrefix: string;
  solrApiHost: string;
  solrApiPrefix: string;
  dataApiHost: string;
  dataApiPrefix: string;
  useMockData: boolean;
  logging: boolean;
  AxiosRequestLogging: boolean;
  AxiosResponseLogging: boolean;
  AxiosHeaderLogging: boolean;
  AxiosBodyLogging: boolean;
  defaultTimeOut: number;
  defaultLanguage: string;
  tempDirPath: string;
  mapTilesCachStoreName: string;
  configModeName: string;
  configModeNameAbr: string;
  mapboxToken: string;
  mapboxUrlTemplate: string;
  mapboxUserAgent: string;
  sentryDsn: string;
  releaseVersionPostfix: string;
  sentryEnabled: boolean;

  constructor(
    tempDirPath: string,
    {
      authApiPrefix = AUTH_API_BASE,
      managementApiPrefix = API_BASE,
      sellerApiPrefix = API_BASE,
      sharedApiPrefix = API_BASE,
      buyerApiPrefix = API_BASE,
      solrApiPrefix = SolrAPIPrefix,
      dataApiPrefix = DataAPIPrefix,
      managementApiHost,
      sellerApiHost,
      buyerApiHost,
      sharedApiHost,
      solrApiHost,
      dataApiHost,
      useMockData = false,
      AxiosHeaderLogging = false,
      AxiosBodyLogging = false,
      AxiosRequestLogging = false,
      AxiosResponseLogging = false,
      logging = true,
      defaultTimeOut = 30,
      defaultLanguage = 'en',
      configModeName = 'Abstract',
      configModeNameAbr = 'Abs',
      mapboxToken = 'pk.eyJ1IjoiaWJyYWhlZW1hbHlhbiIsImEiOiJjbGRibGVkb3QwMDU4M29vYmYxd3RlY29uIn0.RK27OZK7l2oAvFDlcI_NsA',
      mapboxUserAgent = 'silal.shared_lib',
      mapboxUrlTemplate = 'https://api.mapbox.com/styles/v1/ibraheemalyan/cldblnnxz001101s5y1e1gigo/tiles/512/{z}/{x}/{y}@2x?access_token={access_token}',
      mapTilesCachStoreName = 'map_tiles_cache',
      sentryDsn = 'https://c9db436ec40f48f0ae817914cabfe2f7@monitor.cloud.silal.app/4',
      releaseVersionPostfix = '0.0.1',
      sentryEnabled = false,
    }: Partial<Config>,
  ) {
    this.managementApiPrefix = managementApiPrefix;
    this.sellerApiPrefix = sellerApiPrefix;
    this.buyerApiPrefix = buyerApiPrefix;
    this.authApiPrefix = authApiPrefix;
    this.sharedApiPrefix = sharedApiPrefix;
    this.solrApiPrefix = solrApiPrefix;
    this.dataApiPrefix = dataApiPrefix;
    this.managementApiHost = managementApiHost!;
    this.sellerApiHost = sellerApiHost!;
    this.buyerApiHost = buyerApiHost!;
    this.sharedApiHost = sharedApiHost!;
    this.solrApiHost = solrApiHost!;
    this.dataApiHost = dataApiHost!;
    this.useMockData = useMockData;
    this.logging = logging;
    this.AxiosRequestLogging = AxiosRequestLogging;
    this.AxiosResponseLogging = AxiosResponseLogging;
    this.AxiosHeaderLogging = AxiosHeaderLogging;
    this.AxiosBodyLogging = AxiosBodyLogging;
    this.defaultTimeOut = defaultTimeOut;
    this.defaultLanguage = defaultLanguage;
    this.tempDirPath = tempDirPath;
    this.mapTilesCachStoreName = mapTilesCachStoreName;
    this.configModeName = configModeName;
    this.configModeNameAbr = configModeNameAbr;
    this.mapboxToken = mapboxToken;
    this.mapboxUrlTemplate = mapboxUrlTemplate;
    this.mapboxUserAgent = mapboxUserAgent;
    this.sentryDsn = sentryDsn;
    this.releaseVersionPostfix = releaseVersionPostfix;
    this.sentryEnabled = sentryEnabled;
  }

  baseUrl(): string {
    return this.managementApiHost + this.managementApiPrefix;
  }
}

class DevConfig extends Config {
  constructor(tempDirPath: string) {
    super(tempDirPath, {
      managementApiHost: MANAGEMENT_HOST_DEV,
      sellerApiHost: SELLER_HOST_DEV,
      sharedApiHost: SHARED_HOST_DEV,
      buyerApiHost: BUYER_HOST_DEV,
      solrApiHost: SEARCH_HOST_DEV,
      dataApiHost: DATA_HOST_DEV,
      logging: true,
      AxiosRequestLogging: true,
      AxiosResponseLogging: true,
      defaultTimeOut: 30,
      configModeName: 'development',
      configModeNameAbr: 'dev',
    });
  }
}

class ProductionConfig extends Config {
  constructor(tempDirPath: string) {
    super(tempDirPath, {
      managementApiHost: MANAGEMENT_HOST_PROD,
      sellerApiHost: SELLER_HOST_PROD,
      sharedApiHost: SHARED_HOST_PROD,
      buyerApiHost: BUYER_HOST_PROD,
      solrApiHost: SEARCH_HOST_PROD,
      dataApiHost: DATA_HOST_PROD,
      logging: false,
      AxiosRequestLogging: true,
      AxiosResponseLogging: true,
      defaultTimeOut: 30,
      configModeName: 'production',
      configModeNameAbr: 'prod',
    });
  }
}
export class ConfigSelector {
  static getConfig(tempDirPath: string) {
    const configMode = getCurrentEnviromentType();
    switch (configMode) {
      case ENVIROMENT_TYPE.DEVELOPMENT:
        return new DevConfig(tempDirPath);
      case ENVIROMENT_TYPE.PRODUCTION:
        return new ProductionConfig(tempDirPath);
      default:
        return new DevConfig(tempDirPath);
    }
  }
}
